goog.provide("shadow.js.shim.module$src$svg$organisations$other$facebook_svg$default");
shadow.js.shim.module$src$svg$organisations$other$facebook_svg$default = shadow.js.shim.module$src$svg$organisations$other$facebook_svg.default;
